import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const ticketAiTag = "TicketAi";

export interface TicketAiPreCheckResult {
  ticketsWithMissingTexts: { ticket_id: number; title: string }[];
  approvableTickets: { ticket_id: number; title: string }[];
  ticketsWithoutKb: { ticket_id: number; title: string }[];
  totalTickets: number;
}

export interface TicketAiApproveResult {
  approvedCount: number;
  approvedTicketIds: number[];
}

const ticketAiApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResolvedTicketsForAiReview: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const queryString = params
          ? new URLSearchParams(flattenQueryParams(params)).toString()
          : "";
        return `/gw/tickets/ai-review${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [ticketAiTag],
    }),
    updateTicketAiFields: builder.mutation<any, { ticket_id: number } & Record<string, any>>({
      query: ({ ticket_id, ...data }) => ({
        url: `/gw/tickets/${ticket_id}/ai-edit`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [ticketAiTag],
    }),
    ticketAiApprovePreCheck: builder.mutation<TicketAiPreCheckResult, { ticket_ids: number[] }>({
      query: (data) => ({
        url: `/gw/tickets/ai-approve/pre-check`,
        method: "POST",
        body: data,
      }),
    }),
    ticketAiBulkApprove: builder.mutation<
      TicketAiApproveResult,
      { ticket_ids: number[]; language: "en" | "tr" | "english" | "turkish" }
    >({
      query: (data) => ({
        url: `/gw/tickets/ai-approve`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [ticketAiTag, "KbIssue", "KbSolution"],
    }),
    reVectorizeTickets: builder.mutation<
      { message: string },
      { ticket_ids: number[]; language: "en" | "tr" | "english" | "turkish" }
    >({
      query: (data) => ({
        url: `/gw/tickets/ai-re-vectorize`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [ticketAiTag],
    }),
  }),
});

export const {
  useGetResolvedTicketsForAiReviewQuery,
  useUpdateTicketAiFieldsMutation,
  useTicketAiApprovePreCheckMutation,
  useTicketAiBulkApproveMutation,
  useReVectorizeTicketsMutation,
} = ticketAiApi;
